/**
 * Created by piotr.pozniak@thebeaverhead.com on 25/06/2019.
 */

import { PLAN_NAMES, PLANS, QUOTAS, UsageFieldsMapping } from "../../consts";

/**
 *
 * @returns {boolean}
 */
export function updateJquery(retries = 0) {
  try {
    if (retries > 3) {
      return;
    }
    window.updateJquery();
    // console.log("jquery happily updated");
    return true;
  } catch (e) {
    setTimeout(() => updateJquery(retries + 1), 40);
    console.log("updating query failed");
  }
}

/**
 *
 * @param modalSelector
 */
export function hideModal(modalSelector) {
  window.$ && window.$(modalSelector).modal("hide");
}

/**
 *
 * @type {Intl.NumberFormat}
 */
export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

/**
 *
 * @type {Intl.NumberFormat}
 */
export const timeFormatter = new Intl.DateTimeFormat("en-US", {
  dateStyle: "full",
  timeStyle: "short",
});

/**
 *
 * @param arr
 * @returns {*}
 */
export function arrayUnique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) >= index;
  });
}

/**
 *
 * @param plans
 * @returns {*}
 */
export const getCurrentPlan = (plans) => {
  const validPlan = plans.reduce(
    (highest, plan) => (plan.created >= highest.created ? plan : highest),
    { created: 0 }
  );

  if (validPlan) {
    return validPlan;
  }

  const freePlan = plans.find((i) => i.code === PLANS.free);

  if (freePlan) {
    return freePlan;
  }

  return validPlan;
};

/**
 * From: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
 * @param text
 */
export const copyTextToClipboard = (text) => {
  var textArea = document.createElement("textarea");

  //
  // *** This styling is an extra step which is likely not required. ***
  //
  // Why is it here? To ensure:
  // 1. the element is able to have focus and selection.
  // 2. if element was to flash render it has minimal visual impact.
  // 3. less flakyness with selection and copying which **might** occur if
  //    the textarea element is not visible.
  //
  // The likelihood is the element won't even render, not even a
  // flash, so some of these are just precautions. However in
  // Internet Explorer the element is visible whilst the popup
  // box asking the user for permission for the web page to
  // copy to the clipboard.
  //

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = "fixed";
  textArea.style.top = 0;
  textArea.style.left = 0;

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = "2em";
  textArea.style.height = "2em";

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0;

  // Clean up any borders.
  textArea.style.border = "none";
  textArea.style.outline = "none";
  textArea.style.boxShadow = "none";

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = "transparent";

  textArea.value = text;

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    console.log("Copying text command was " + msg);
  } catch (err) {
    console.log("Oops, unable to copy");
  }

  document.body.removeChild(textArea);
};

export const calendarSettingsValidator = (data) => {
  const errors = {};

  if (!data.name || !data.name.length) {
    errors.nameError = "Please enter a Calendar Name. ";
  }

  if (!data.integration_uuid || data.integration_uuid.length <= 1) {
    errors.integrationError = "Please choose an integration. ";
  }

  return errors;
};

/**
 *
 * @param data
 * @returns {{}}
 */
export const groupSettingsValidator = (data) => {
  const errors = {};

  if (!data.name || !data.name.length) {
    errors.nameError = "Please enter a Widget Name. ";
  }

  if (!data.integration_uuid || data.integration_uuid.length <= 1) {
    errors.integrationError = "Please choose an integration. ";
  }

  return errors;
};
/**
 *
 * @param data
 * @returns {{}}
 */
export const alertSettingsValidator = (data) => {
  const errors = {};

  if (!data.name || !data.name.length) {
    errors.nameError = "Please enter a Widget Name. ";
  }

  if (!data.integration_uuid || data.integration_uuid.length <= 1) {
    errors.integrationError = "Please choose an integration. ";
  }

  return errors;
};

/**
 *
 * @param data
 * @returns {{}}
 */
export const widgetSettingsValidator = (data) => {
  const errors = {};

  if (!data.name || !data.name.length) {
    errors.nameError = "Please enter a Widget Name. ";
  }

  if (!data.integration_uuid || data.integration_uuid.length <= 1) {
    errors.integrationError = "Please choose an integration. ";
  }

  return errors;
};

const hasRemainingQuota = (organization, quotaType) => {
  const quota = Number(organization.subscription?.quotas[quotaType]);
  const usage = Number(
    organization.model.usage?.[UsageFieldsMapping[quotaType]]
  );

  return quota === -1 || usage <= quota;
};

export const hasRemainingWidgetQuota = (organization) => {
  return hasRemainingQuota(organization, QUOTAS.widgets);
};

export const canPublishWidgetWithinQuota = (organization, isPublished) => {
  const quota = Number(organization.subscription?.quotas[QUOTAS.widgets]);
  let usage = Number(
    organization.model.usage?.[UsageFieldsMapping[QUOTAS.widgets]]
  );

  if (!isPublished) {
    usage += 1;
  }

  return quota === -1 || usage <= quota;
};

export const hasRemainingDomainsQuota = (organization) => {
  return hasRemainingQuota(organization, QUOTAS.domains);
};

export const hasRemainingIntegrationsQuota = (organization) => {
  return hasRemainingQuota(organization, QUOTAS.integrations);
};

export const hasRemainingTeamQuota = (organization) => {
  return hasRemainingQuota(organization, QUOTAS.team);
};

/**
 *
 * @param organization
 * @returns {string}
 */
export const getTheLowestPlanMeetingCalendarCriteria = (organization) => {
  // return always a plan that is one level higher than the current plan
  // if the current plan is the highest, return "Enterprise - contact us"

  // uses PLANS object to determine the next plan
  const currentPlan = organization.subscription;
  const currentPlanCode = currentPlan.code;

  const currentPlanIndex = Object.values(PLANS).indexOf(currentPlanCode);
  const nextPlanIndex = currentPlanIndex + 1;
  const nextPlanCode = Object.values(PLANS).find(
    (key, idx) => idx === nextPlanIndex
  );

  if (nextPlanCode) {
    return PLAN_NAMES[nextPlanCode];
  }

  return "Enterprise - contact us";
};

/**
 *
 * @param durationInSeconds
 * @returns {`${string|string} ${string|string} ${string|string}`}
 */
export const durationToString = (durationInSeconds) => {
  const duration = new Date(durationInSeconds * 1000);
  const hours = duration.getUTCHours();
  const minutes = duration.getUTCMinutes();
  const seconds = duration.getUTCSeconds();

  return `${hours ? hours + "h" : ""} ${minutes ? minutes + "m" : ""} ${
    seconds ? seconds + "s" : ""
  }`;
};

/**
 * Tests if value is an object.
 * @param value
 * @returns {boolean}
 */
export const isObject = (value) => {
  return value && typeof value === "object" && value.constructor === Object;
};

/**
 * Tests if value is an array.
 * @param value
 * @returns {boolean}
 */
export const isArray = (value) => {
  return value && typeof value === "object" && value.constructor === Array;
};
